export const translations = {
  en: {
    // Auth
    login: "Login",
    mobileNumber: "Mobile Number",
    enterMobile: "Enter your 10-digit mobile number",
    sendOtp: "Send OTP",
    enterOtp: "Enter OTP",
    verifyOtp: "Verify & Login",
    otpSentTo: "OTP sent to",
    resendOtp: "Resend OTP",
    back: "Back",
    welcomeBack: "Welcome Back",
    loginSubtitle: "Enter your mobile number to access your dashboard",
    devLogin: "Developer Login",
    devLoginSubtitle: "Authorized personnel only",
    email: "Email Address",
    username: "Username",
    password: "Password",
    continue: "Continue",
    verifyOtpStep: "Verify OTP",
    mockModeAlert: "Demo Mode: OTP shown for testing",
    yourOtp: "Your OTP",

    // Navigation
    dashboard: "Dashboard",
    overview: "Overview",
    logout: "Logout",
    settings: "Settings",
    adminUsers: "Admin Users",
    ngoUsers: "NGO Users",
    masterWallet: "Master Wallet",
    apiKeys: "API & Keys",
    bundleSettings: "Bundle Settings",
    smsTemplates: "SMS Templates",
    logoSettings: "Logo Settings",
    blockedNumbers: "Blocked Numbers",
    emailTemplates: "Email Templates",
    auditLogs: "Audit Logs",
    emailLogs: "Email Logs",
    smsLogs: "SMS Logs",
    kycReports: "KYC & Reports",
    creditReport: "Credit Report",
    purchaseCredits: "Purchase Credits",
    usageLogs: "Usage Logs",
    naReports: "N/A Reports",
    naOverview: "N/A Overview",
    pullAnalytics: "Pull Analytics",
    purchaseHistory: "Purchase History",
    creditLedger: "Credit Ledger",
    myReports: "My Reports",

    // Theme & Lang
    darkMode: "Dark",
    lightMode: "Light",
    language: "Language",

    // Stats cards
    walletBalance: "Wallet Balance",
    totalReports: "Reports Pulled",
    totalDownloads: "Downloaded",
    totalAdmins: "Total Admins",
    totalNGOs: "Total NGOs",
    credits: "Credits",
    masterBalance: "Master Balance",
    totalSms: "Total SMS Sent",
    pendingNotifs: "Pending Alerts",
    ngoCredits: "NGO Credits",
    adminCredits: "Admin Credits",

    // Credit report
    firstName: "First Name",
    lastName: "Last Name",
    mobileNo: "Mobile Number",
    getCreditReport: "Get Credit Report",
    consentRequired: "Please accept the terms to proceed",
    loadingReport: "Fetching Credit Report",
    loadingDesc: "Please wait while we pull the credit information...",
    downloadReport: "Download Report",
    printReport: "Print",
    creditScore: "Credit Score",
    excellent: "Excellent",
    good: "Good",
    fair: "Fair",
    poor: "Poor",
    customerIdentity: "Customer Identity",
    accountSummary: "Account Summary",
    accountHistory: "Account History",
    inquiryHistory: "Inquiry History",
    scoreHistory: "Score History",
    pullNewReport: "Pull New Report",

    // Low credits
    lowCreditsTitle: "Insufficient Credits",
    lowCreditsMsg: "You don't have enough credits to pull a report.",
    purchaseMore: "Purchase Credits",
    contactAdmin: "Contact Admin",

    // Actions
    create: "Create",
    createAdmin: "Create Admin",
    createNgo: "Create NGO User",
    assign: "Assign Credits",
    remove: "Remove",
    save: "Save Changes",
    cancel: "Cancel",
    update: "Update",
    addCredits: "Add Credits",
    assignToAdmin: "Assign to Admin",
    removeFromAdmin: "Remove from Admin",
    assignToNgo: "Assign to NGO",
    reassignCredits: "Reassign Credits",

    // Status
    active: "Active",
    suspended: "Suspended",
    pending: "Pending",
    completed: "Completed",
    failed: "Failed",
    mock: "Mock",
    sent: "Sent",

    // Forms
    name: "Full Name",
    mobile: "Mobile Number",
    numberOfCredits: "Number of Credits",
    reason: "Reason (Optional)",
    apiId: "API ID",
    apiKey: "API Key",
    tokenId: "Token ID",
    baseUrl: "Base URL",
    authKey: "Auth Key",
    senderId: "Sender ID",
    razorpayKeyId: "Razorpay Key ID",
    razorpayKeySecret: "Razorpay Key Secret",
    logoUrl: "Logo URL",
    logoSize: "Logo Size",
    small: "Small",
    medium: "Medium",
    large: "Large",
    testConnection: "Test Connection",
    connected: "Connected",
    notConfigured: "Not Configured",

    // Bundles
    bundle1: "Bundle 1",
    bundle2: "Bundle 2",
    perCredit: "per credit",
    buyNow: "Purchase Now",
    bundleCredits: "Credits",
    bundlePrice: "Price",

    // SMS Templates
    developerNotifContent: "Developer Notification SMS",
    ngoActivationContent: "NGO Activation SMS",
    adminActivationContent: "Admin Activation SMS",
    checkboxContent: "Consent Checkbox Text",
    templateVars: "Use {login_url} for login link",

    // Users table
    userName: "Name",
    userMobile: "Mobile",
    userStatus: "Status",
    userBalance: "Credits",
    userReports: "Reports",
    userCreated: "Created",
    actions: "Actions",
    suspend: "Suspend",
    activate: "Activate",
    noUsers: "No users found",

    // Logs
    action: "Action",
    details: "Details",
    ipAddress: "IP Address",
    timestamp: "Timestamp",
    recipient: "Recipient",
    message: "Message",
    purpose: "Purpose",
    status: "Status",
    noLogs: "No logs available",

    // Ledger
    type: "Type",
    amount: "Amount",
    balanceAfter: "Balance After",
    description: "Description",
    date: "Date",

    // Misc
    success: "Success",
    error: "Error",
    loading: "Loading...",
    noData: "No data available",
    refresh: "Refresh",
    search: "Search...",
    close: "Close",
    confirm: "Confirm",
    demo: "DEMO",
    totalAssigned: "Total Assigned",
    totalUsed: "Total Used",
    totalPurchased: "Total Purchased",
  },

  ta: {
    // Auth
    login: "உள்நுழைவு",
    mobileNumber: "மொபைல் எண்",
    enterMobile: "உங்கள் 10 இலக்க மொபைல் எண்ணை உள்ளிடவும்",
    sendOtp: "OTP அனுப்பவும்",
    enterOtp: "OTP உள்ளிடவும்",
    verifyOtp: "சரிபார்த்து உள்நுழைவு",
    otpSentTo: "OTP அனுப்பப்பட்டது",
    resendOtp: "OTP மீண்டும் அனுப்பவும்",
    back: "திரும்பு",
    welcomeBack: "மீண்டும் வரவேற்கிறோம்",
    loginSubtitle: "உங்கள் டாஷ்போர்டை அணுக மொபைல் எண்ணை உள்ளிடவும்",
    devLogin: "டெவலப்பர் உள்நுழைவு",
    devLoginSubtitle: "அங்கீகரிக்கப்பட்ட பணியாளர்கள் மட்டுமே",
    email: "மின்னஞ்சல் முகவரி",
    username: "பயனர்பெயர்",
    password: "கடவுச்சொல்",
    continue: "தொடரவும்",
    verifyOtpStep: "OTP சரிபார்க்கவும்",
    mockModeAlert: "டெமோ பயன்முறை: சோதனைக்கு OTP காட்டப்படுகிறது",
    yourOtp: "உங்கள் OTP",

    // Navigation
    dashboard: "டாஷ்போர்டு",
    overview: "கண்ணோட்டம்",
    logout: "வெளியேறு",
    settings: "அமைப்புகள்",
    adminUsers: "நிர்வாக பயனர்கள்",
    ngoUsers: "NGO பயனர்கள்",
    masterWallet: "மாஸ்டர் பணப்பை",
    apiKeys: "API & விசைகள்",
    bundleSettings: "தொகுப்பு அமைப்புகள்",
    smsTemplates: "SMS வார்ப்புருக்கள்",
    logoSettings: "லோகோ அமைப்புகள்",
    blockedNumbers: "தடுக்கப்பட்ட எண்கள்",
    emailTemplates: "மின்னஞ்சல் வார்ப்புருக்கள்",
    auditLogs: "தணிக்கை பதிவுகள்",
    emailLogs: "மின்னஞ்சல் பதிவுகள்",
    smsLogs: "SMS பதிவுகள்",
    kycReports: "KYC & அறிக்கைகள்",
    creditReport: "கடன் அறிக்கை",
    purchaseCredits: "கடன்கள் வாங்கவும்",
    usageLogs: "பயன்பாட்டு பதிவுகள்",
    naReports: "N/A அறிக்கைகள்",
    naOverview: "N/A மேலோட்டம்",
    pullAnalytics: "இழுக்கும் பகுப்பாய்வு",
    purchaseHistory: "கொள்முதல் வரலாறு",
    creditLedger: "கடன் பேரேடு",
    myReports: "என் அறிக்கைகள்",

    // Theme & Lang
    darkMode: "இருண்ட",
    lightMode: "ஒளி",
    language: "மொழி",

    // Stats
    walletBalance: "பணப்பை இருப்பு",
    totalReports: "இழுக்கப்பட்ட அறிக்கைகள்",
    totalDownloads: "பதிவிறக்கம்",
    totalAdmins: "மொத்த நிர்வாகிகள்",
    totalNGOs: "மொத்த NGO கள்",
    credits: "கடன்கள்",
    masterBalance: "மாஸ்டர் இருப்பு",
    totalSms: "மொத்த SMS",
    pendingNotifs: "நிலுவை அறிவிப்புகள்",
    ngoCredits: "NGO கடன்கள்",
    adminCredits: "நிர்வாக கடன்கள்",

    // Credit report
    firstName: "முதல் பெயர்",
    lastName: "கடைசி பெயர்",
    mobileNo: "மொபைல் எண்",
    getCreditReport: "கடன் அறிக்கை பெறுக",
    consentRequired: "தொடர விதிமுறைகளை ஏற்கவும்",
    loadingReport: "கடன் அறிக்கை பெறப்படுகிறது",
    loadingDesc: "தயவுசெய்து காத்திருங்கள்...",
    downloadReport: "அறிக்கை பதிவிறக்கம்",
    printReport: "அச்சிடு",
    creditScore: "கடன் மதிப்பெண்",
    excellent: "சிறப்பானது",
    good: "நல்லது",
    fair: "நியாயமான",
    poor: "மோசமான",
    customerIdentity: "வாடிக்கையாளர் அடையாளம்",
    accountSummary: "கணக்கு சுருக்கம்",
    accountHistory: "கணக்கு வரலாறு",
    inquiryHistory: "விசாரணை வரலாறு",
    scoreHistory: "மதிப்பெண் வரலாறு",
    pullNewReport: "புதிய அறிக்கை",

    // Low credits
    lowCreditsTitle: "போதிய கடன்கள் இல்லை",
    lowCreditsMsg: "அறிக்கை பெற போதிய கடன்கள் இல்லை.",
    purchaseMore: "கடன்கள் வாங்கவும்",
    contactAdmin: "நிர்வாகியை தொடர்பு கொள்ளவும்",

    // Actions
    create: "உருவாக்கு",
    createAdmin: "நிர்வாகி உருவாக்கு",
    createNgo: "NGO பயனர் உருவாக்கு",
    assign: "கடன்கள் ஒதுக்கு",
    remove: "நீக்கு",
    save: "சேமி",
    cancel: "ரத்து",
    update: "புதுப்பி",
    addCredits: "கடன்கள் சேர்",
    assignToAdmin: "நிர்வாகிக்கு ஒதுக்கு",
    removeFromAdmin: "நிர்வாகியிடம் நீக்கு",
    assignToNgo: "NGO க்கு ஒதுக்கு",
    reassignCredits: "மீண்டும் ஒதுக்கு",

    // Status
    active: "செயலில்",
    suspended: "நிறுத்தப்பட்டது",
    pending: "நிலுவையில்",
    completed: "முடிந்தது",
    failed: "தோல்வி",
    mock: "டெமோ",
    sent: "அனுப்பப்பட்டது",

    // Forms
    name: "முழு பெயர்",
    mobile: "மொபைல் எண்",
    numberOfCredits: "கடன்களின் எண்ணிக்கை",
    reason: "காரணம் (விருப்பம்)",
    apiId: "API ID",
    apiKey: "API விசை",
    tokenId: "Token ID",
    baseUrl: "அடிப்படை URL",
    authKey: "Auth விசை",
    senderId: "Sender ID",
    razorpayKeyId: "Razorpay Key ID",
    razorpayKeySecret: "Razorpay Key Secret",
    logoUrl: "லோகோ URL",
    logoSize: "லோகோ அளவு",
    small: "சிறியது",
    medium: "நடுத்தரம்",
    large: "பெரியது",
    testConnection: "இணைப்பை சோதி",
    connected: "இணைக்கப்பட்டது",
    notConfigured: "கட்டமைக்கப்படவில்லை",

    // Bundles
    bundle1: "தொகுப்பு 1",
    bundle2: "தொகுப்பு 2",
    perCredit: "ஒவ்வொரு கடனுக்கும்",
    buyNow: "இப்போது வாங்கவும்",
    bundleCredits: "கடன்கள்",
    bundlePrice: "விலை",

    // SMS Templates
    developerNotifContent: "டெவலப்பர் அறிவிப்பு SMS",
    ngoActivationContent: "NGO செயல்படுத்தல் SMS",
    adminActivationContent: "நிர்வாகி செயல்படுத்தல் SMS",
    checkboxContent: "சம்மத பெட்டி உரை",
    templateVars: "உள்நுழைவு இணைப்புக்கு {login_url} பயன்படுத்தவும்",

    // Users table
    userName: "பெயர்",
    userMobile: "மொபைல்",
    userStatus: "நிலை",
    userBalance: "கடன்கள்",
    userReports: "அறிக்கைகள்",
    userCreated: "உருவாக்கிய தேதி",
    actions: "செயல்கள்",
    suspend: "நிறுத்து",
    activate: "செயல்படுத்து",
    noUsers: "பயனர்கள் இல்லை",

    // Logs
    action: "செயல்",
    details: "விவரங்கள்",
    ipAddress: "IP முகவரி",
    timestamp: "நேரம்",
    recipient: "பெறுநர்",
    message: "செய்தி",
    purpose: "நோக்கம்",
    status: "நிலை",
    noLogs: "பதிவுகள் இல்லை",

    // Misc
    success: "வெற்றி",
    error: "பிழை",
    loading: "ஏற்றுகிறது...",
    noData: "தரவு இல்லை",
    refresh: "புதுப்பி",
    search: "தேடு...",
    close: "மூடு",
    confirm: "உறுதிப்படுத்து",
    demo: "டெமோ",
    totalAssigned: "மொத்த ஒதுக்கீடு",
    totalUsed: "மொத்த பயன்பாடு",
    totalPurchased: "மொத்த கொள்முதல்",
    ledger: "பேரேடு",
    description: "விளக்கம்",
    date: "தேதி",
    type: "வகை",
    amount: "தொகை",
    balanceAfter: "இருப்பு பிறகு",
  }
};
